import IconReusable from '../../components/IconReusable';

export const getTabConfig = (isPwa, menuLabelMap) => [
  {
    label: menuLabelMap?.home || 'Home',
    path: isPwa ? '/pwa-main-menu' : '/',
    inactiveIcon: <IconReusable name="HomeOutlined" size={24}  />,
    activeIcon: <IconReusable name="HomeFilled" size={24}  />,
    key: 'home',
    visible: true,
  },
  {
    label: menuLabelMap?.my_business || 'My Business',
    path: '/my-business',
    inactiveIcon: <IconReusable name="BusinessOutlined" size={24}  />,
    activeIcon: <IconReusable name="BusinessFilled" size={24}  />,
    key: 'inventory',
  },
  {
    label: menuLabelMap?.my_network || 'My Network',
    path: '/my-network',
    inactiveIcon: <IconReusable name="Network" size={24}  />,
    activeIcon: <IconReusable name="NetworkFilled" size={24}  />,
    key: 'my_network',
  },
  {
    label: menuLabelMap?.my_benefits || 'Benefits',
    path: '/benefits/mybenefits',
    inactiveIcon: <IconReusable name="BenefitsOutlined" size={24}  />,
    activeIcon: <IconReusable name="BenefitsOutlined" size={24}  />,
    key: 'my_benefits',
  },
  {
    label: menuLabelMap?.performance || 'Performance',
    path: '/my-performance/network-performance',
    inactiveIcon: <IconReusable name="PerformanceOutlined" size={24}  />,
    activeIcon:  <IconReusable name="PerformanceOutlined" size={24}  />,
    key: 'network_performance',
  },
];

